import { get, post } from 'axios'
// import store from '@/store'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization: `Bearer ${store.state.user.attributes.token}` }

//post
function getSalesAdvisorSalesAdvisorPermissions (pIdSalesAdvisor) {
    const URI = `${BASE_URL}/api/salesAdvisors/${pIdSalesAdvisor}/salesAdvisorPermissions`
    return get(URI, { headers })
}

function updateSalesAdvisorSalesAdvisorPermissions (pFormData, pIdSalesAdvisor, pIdSalesAdvisorPermission,) {
    const URI = `${BASE_URL}/api/salesAdvisors/${pIdSalesAdvisor}/salesAdvisorPermissions/${pIdSalesAdvisorPermission}`
    return post(URI, pFormData, { headers })
}

export {
    getSalesAdvisorSalesAdvisorPermissions,
    updateSalesAdvisorSalesAdvisorPermissions
}